<script>
  export default {
    name: 'Halloween',

    computed: {
      getImageUrl() {
        const isDesktop = this.$vuetify.breakpoint.width > 600;

        return `/images/halloween/cards${this.$route.path}-${isDesktop ? 'desktop' : 'mobile'}.webp?v=1`;
      },
    },

    methods: {
      openSignUpDialog() {
        this.$store.dispatch('changeSignupDialogState', true);
      },
    },
  };
</script>

<template>
  <div class="page-background">
    <div class="container">
      <img class="banner position-relative" :src="getImageUrl" alt="halloween" @click="openSignUpDialog()" />
      <span class="text-uppercase text-center caption-text">
        New depositors only, one time per user
        <br />
        DEPOSIT WITH CRYPTO OR USD
      </span>
    </div>
  </div>
</template>

<style scoped lang="scss">
  .page-background {
    display: flex;
    justify-content: center;
    width: 100%;
    height: 100%;
    background-image: url('/images/halloween/background-moon-desktop.webp');
    background-size: cover;

    @media screen and (max-width: 600px) {
      background-image: url('/images/halloween/background-mobile.webp');
      padding-bottom: 500px;
      background-size: cover;
    }
  }

  .container {
    padding-top: 37px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 100%;
    width: 80%;
    color: white;

    .banner {
      cursor: pointer;
      border-radius: 8px;
      width: 100%;
      max-width: 1200px;
      margin-bottom: 51px;
    }

    .caption-text {
      font-size: 22px;
      font-weight: 600;
      text-wrap: nowrap;
    }

    @media screen and (max-width: 600px) {
      width: 96%;

      .banner {
        margin-bottom: 37px;
      }

      .caption-text {
        font-size: 18px;
      }
    }
  }
</style>
